import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ButtonBase from '@material-ui/core/ButtonBase';

import Grid from '../Grid';
import styles from './styles';

class Card extends React.PureComponent {
  renderInner() {
    const { children, textcolor, imgSrc, title, classes } = this.props;

    return (
      <Grid spacing={0} sm={12} md={6} className={classes.grid} alignItems="stretch">
        <img key="img" src={imgSrc} alt="" className={classes.image} />
        <Grid
          key="content"
          direction="column"
          spacing={0}
          justifyContent="space-between"
          className={classes.textContent}
        >
          <Typography key="title" variant="h5" className={`${classes[textcolor]}`}>
            {title}
          </Typography>
          <div key="children">{children}</div>
        </Grid>
      </Grid>
    );
  }

  getButtonProps() {
    const { classes, onClick, ButtonProps } = this.props;
    return {
      focusRipple: true,
      onClick,
      className: classes.container,
      ...ButtonProps,
    };
  }

  getPaperProps() {
    const { classes, PaperProps } = this.props;
    return {
      elevation: 0,
      square: true,
      className: classes.container,
      ...PaperProps,
    };
  }

  render() {
    const { onClick } = this.props;
    const Wrapper = onClick ? ButtonBase : Paper;
    const wrapperProps = onClick ? this.getButtonProps() : this.getPaperProps();
    return <Wrapper {...wrapperProps}>{this.renderInner()}</Wrapper>;
  }
}

Card.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  textcolor: PropTypes.string,
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.any,
  onClick: PropTypes.func,
  PaperProps: PropTypes.object,
  ButtonProps: PropTypes.object,
};

Card.defaultProps = {
  textcolor: 'black',
};

export default withStyles(styles)(Card);
